module.exports = __webpack_public_path__ + "static/media/undraw_target_kriv.1a3aa16b.svg";